export default __webpack_public_path__ + "static/media/thumb-NDNU-3.88f43a1a.png";